(function () {
  'use strict';
  function rs(n) { return 'Rs. ' + n.toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
  function unitOf(el) {
    var m = el && el.textContent.match(/[\d,]+(\.\d+)?/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : null;
  }

  // product page: button price follows the quantity
  var q = document.getElementById('pdp-qty');
  var p = document.querySelector('.zadd-price');
  var unit = unitOf(document.querySelector('[data-price]'));
  if (q && p && unit !== null) {
    var upd = function () { p.textContent = rs(unit * Math.max(1, parseInt(q.value, 10) || 1)); };
    q.addEventListener('input', upd);
    q.addEventListener('change', upd);
    var w = q.closest('.zqty');
    if (w) w.addEventListener('click', function () { setTimeout(upd, 0); });
    upd();
  }

  // product cards: quantity stepper, and the card price follows the quantity
  document.querySelectorAll('#range article form[data-ajax-cart], .card form[data-ajax-cart]').forEach(function (form) {
    var qty = form.querySelector('input[name=quantity]');
    var btn = form.querySelector('[type=submit]');
    if (!qty || !btn || form.querySelector('.zqty')) return;
    var row = form.parentElement;
    var card = form.closest('.card');
    var priceEl = card ? card.querySelector('.price') : row.querySelector('span');
    var u = priceEl && !priceEl.children.length ? unitOf(priceEl) : null;
    var wrap = document.createElement('div');
    wrap.className = 'zqty';
    wrap.style.cssText = 'height:46px;flex:none';
    var minus = document.createElement('button'), num = document.createElement('span'), plus = document.createElement('button');
    minus.type = plus.type = 'button';
    minus.textContent = '−'; plus.textContent = '+'; num.textContent = '1';
    minus.style.width = plus.style.width = '36px';
    minus.style.fontSize = plus.style.fontSize = '18px';
    num.style.width = '24px';
    num.setAttribute('aria-live', 'polite');
    minus.setAttribute('aria-label', 'Decrease quantity'); plus.setAttribute('aria-label', 'Increase quantity');
    wrap.appendChild(minus); wrap.appendChild(num); wrap.appendChild(plus);
    form.insertBefore(wrap, btn);
    form.style.cssText = 'display:flex;align-items:center;gap:8px;flex:1 1 100%;margin:0';
    btn.style.flex = '1 1 auto';
    btn.style.marginTop = '0';
    if (!card) row.style.flexWrap = 'wrap';
    function set(n) {
      n = Math.max(1, n);
      qty.value = n; num.textContent = n;
      if (u !== null) priceEl.textContent = rs(u * n);
    }
    minus.addEventListener('click', function () { set((parseInt(qty.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { set((parseInt(qty.value, 10) || 1) + 1); });
  });
})();

/* Address opens Google Maps directions; phone number always responds to a click */
(function () {
  'use strict';
  var ADDR = 'NuTaste Food Labs Pvt. Ltd., 45 Milestone, Naurangpur Road, Sector 78, Gurugram 122050, Haryana';
  var MAP = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(ADDR);
  var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n, hits = [];
  while ((n = tw.nextNode())) {
    if (n.nodeValue.indexOf('Naurangpur') > -1 && !n.parentElement.closest('a, script, style, textarea, select')) hits.push(n);
  }
  hits.forEach(function (t) {
    var a = document.createElement('a');
    a.href = MAP; a.target = '_blank'; a.rel = 'noopener';
    a.setAttribute('aria-label', 'Get directions to ' + ADDR + ' on Google Maps (opens in a new tab)');
    var row = t.parentElement.closest('.zeel-row');
    if (row) {
      a.className = row.className;
      a.style.cssText = row.style.cssText + ';text-decoration:none;color:#14301c';
      while (row.firstChild) a.appendChild(row.firstChild);
      row.parentNode.replaceChild(a, row);
      var hint = document.createElement('span');
      hint.textContent = 'Get directions ↗';
      hint.style.cssText = 'font-size:13px;font-weight:600;color:#1f4d2b;margin-top:2px';
      t.parentElement.parentElement.appendChild(hint);
    } else {
      a.style.cssText = 'color:inherit;text-decoration:underline;text-decoration-color:#9aa890;text-underline-offset:3px';
      t.parentNode.replaceChild(a, t);
      a.appendChild(t);
      var box = a.closest('footer') ? a.parentElement : null;
      if (box) {
        var h = document.createElement('a');
        h.href = MAP; h.target = '_blank'; h.rel = 'noopener';
        h.textContent = 'Get directions ↗';
        h.style.cssText = 'display:block;margin-top:4px;font-weight:600;color:#1f4d2b;text-decoration:none';
        box.appendChild(h);
      }
    }
  });

  // On a computer there is often no calling app, so the click looked dead: copy the number and say so.
  var timer = null;
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="tel:"]') : null;
    if (!a) return;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    var num = a.getAttribute('href').slice(4);
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(num).catch(function () {});
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = 'Number copied: +91 99585 33360. Call us from your phone.';
    toast.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(function () { toast.hidden = true; }, 5000);
  });
})();

/* Shop-all menu: "View all 7 products" tile */
(function () {
  'use strict';
  var strip = document.querySelector('.zeel-lineup-fast');
  var css = document.querySelector("link[href*='zeel.css']");
  var tile = strip && strip.closest('a');
  if (!tile || !css) return;
  var base = css.href.split('zeel.css')[0];
  var items = [['radiance', 'Happy Radiance', '#f3e4bd', '#e2c990'], ['ageing', 'Happy Ageing', '#d8c8ed', '#bfa6e0'], ['hydrate', 'Happy Hydrate', '#c0e0df', '#9dcbc8'], ['dreams', 'Happy Dreams', '#f5cdd5', '#e6aebb'], ['gut', 'Happy Belly Shot', '#cfe0be', '#b1c89a'], ['crisps', 'Protein Crisps', '#f8dc89', '#ecc65b']];
  var st = document.createElement('style');
  st.textContent = '.ztile{position:relative;display:block;height:340px;border-radius:20px;overflow:hidden;background:#f3e4bd;color:#14301c;text-decoration:none;isolation:isolate;transition:background-color .7s ease,box-shadow .25s ease,transform .25s ease}'
    + '.ztile:hover{transform:translateY(-3px);box-shadow:0 14px 28px rgba(20,48,28,.16)}'
    + '.ztile-floor{position:absolute;left:0;right:0;top:221px;bottom:0;background:#e2c990;transition:background-color .7s ease}'
    + '.ztile-imgs img{position:absolute;left:50%;top:-55px;height:345px;width:auto;max-width:none;opacity:0;transform:translateX(-50%) scale(1.07);transform-origin:50% 80%;transition:opacity .7s ease,transform 2.6s ease-out}'
    + '.ztile-imgs img.on{opacity:1;transform:translateX(-50%) scale(1)}'
    + '.ztile-name{position:absolute;top:14px;left:12px;background:#fff;color:#14301c;font-weight:600;font-size:13px;line-height:1;padding:7px 12px;border-radius:14px}'
    + '.ztile-foot{position:absolute;left:14px;right:14px;bottom:12px;display:flex;flex-direction:column;align-items:center;gap:9px}'
    + '.ztile-cta{display:flex;align-items:center;gap:6px;background:#1f4d2b;color:#fff;font-weight:600;font-size:13px;line-height:1;padding:8px 14px;border-radius:16px;transition:background .2s ease}'
    + '.ztile-cta i{font-style:normal;transition:transform .25s ease}'
    + '.ztile:hover .ztile-cta{background:#14301c}.ztile:hover .ztile-cta i{transform:translateX(5px)}'
    + '.ztile-dots{display:flex;gap:5px;justify-content:center}'
    + '.ztile-dots span{width:6px;height:6px;border-radius:3px;background:rgba(20,48,28,.3);transition:width .3s ease,background .3s ease}'
    + '.ztile-dots span.on{width:18px;background:#14301c}'
    + '@media(prefers-reduced-motion:reduce){.ztile,.ztile-floor,.ztile-imgs img,.ztile-cta i,.ztile-dots span{transition:none}}';
  document.head.appendChild(st);
  tile.removeAttribute('style');
  tile.className = 'ztile';
  tile.setAttribute('aria-label', 'View all 7 products');
  tile.innerHTML = '<span class="ztile-floor" aria-hidden="true"></span>'
    + '<span class="ztile-imgs" aria-hidden="true">' + items.map(function () { return '<img alt="">'; }).join('') + '</span>'
    + '<span class="ztile-name" aria-hidden="true"></span>'
    + '<span class="ztile-foot"><span class="ztile-cta">View all <i aria-hidden="true">→</i></span>'
    + '<span class="ztile-dots" aria-hidden="true">' + items.map(function () { return '<span></span>'; }).join('') + '</span></span>';
  var imgs = tile.querySelectorAll('.ztile-imgs img');
  var dots = tile.querySelectorAll('.ztile-dots span');
  var name = tile.querySelector('.ztile-name');
  var floor = tile.querySelector('.ztile-floor');
  var i = -1;
  function load(k) { if (!imgs[k].src) imgs[k].src = base + 'zeel-arch-' + items[k][0] + '.jpg'; }
  function show(k) {
    i = k % items.length;
    load(i); load((i + 1) % items.length);
    for (var j = 0; j < items.length; j++) {
      imgs[j].classList.toggle('on', j === i);
      dots[j].classList.toggle('on', j === i);
    }
    name.textContent = items[i][1];
    tile.style.backgroundColor = items[i][2];
    floor.style.backgroundColor = items[i][3];
  }
  show(0);
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  setInterval(function () { if (tile.offsetParent !== null) show(i + 1); }, 2600);
})();
